// Action Types
import { createAction, handleActions } from "redux-actions";

const SET_TEMPLATE_LIST = 'form/SET_TEMPLATE_LIST';
const SET_SELECTED_TEMPLATE = 'form/SET_SELECTED_TEMPLATE';
const SET_FORM_LIST = 'form/SET_FORM_LIST';
const SET_TOTAL = 'form/SET_TOTAL';
const SET_SIZE = 'form/SET_SIZE';
const SET_PAGE = 'form/SET_PAGE';
const SET_FORM_VARIABLES = 'form/SET_FORM_VARIABLES';
const SET_CREATED_FORM = 'form/SET_CREATED_FORM';

// Actions
export const setTemplateList = createAction(SET_TEMPLATE_LIST);
export const setSelectedTemplate = createAction(SET_SELECTED_TEMPLATE);
export const setFormList = createAction(SET_FORM_LIST);
export const setTotal = createAction(SET_TOTAL);
export const setSize = createAction(SET_SIZE);
export const setPage = createAction(SET_PAGE);
export const setFormVariables = createAction(SET_FORM_VARIABLES);
export const setCreatedForm = createAction(SET_CREATED_FORM);

// Initial State
const initialState = {
    // 템플릿 관련
    templateList: [],
    selectedTemplate: null,
    formVariables: {},

    // 폼 목록 관련
    formList: [],
    total: 0,
    size: 10,
    page: 1,

    // 생성된 폼
    createdForm: null,
};

// Reducer
export default handleActions({
    [SET_TEMPLATE_LIST]: (state, action) => ({
        ...state,
        templateList: action.payload,
    }),
    [SET_SELECTED_TEMPLATE]: (state, action) => ({
        ...state,
        selectedTemplate: action.payload,
        formVariables: {}, // 템플릿 변경 시 변수 초기화
    }),
    [SET_FORM_LIST]: (state, action) => ({
        ...state,
        formList: action.payload,
    }),
    [SET_TOTAL]: (state, action) => ({
        ...state,
        total: action.payload,
    }),
    [SET_SIZE]: (state, action) => ({
        ...state,
        size: action.payload,
    }),
    [SET_PAGE]: (state, action) => ({
        ...state,
        page: action.payload,
    }),
    [SET_FORM_VARIABLES]: (state, action) => ({
        ...state,
        formVariables: action.payload,
    }),
    [SET_CREATED_FORM]: (state, action) => ({
        ...state,
        createdForm: action.payload,
    }),
}, initialState);
